import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useParams } from 'next/navigation';

import type { CommunityMember } from '@zealy/queries';
import { Button, TaskCard, TaskCardHint } from '@zealy/design-system';
import { DiscordBrand, QuestionFilled, TwitterFilled } from '@zealy/icons';
import { useAuthenticatedUser, useCommunity } from '@zealy/queries';
import { roleIsAtLeast } from '@zealy/utils';

import { TASK_CONFIG } from '#constants/quests/Task.constants';
import { useOauth2 } from '#hooks/useOAuth2';

const ConnectDiscord = () => {
  const { subdomain } = useParams<{ subdomain: string }>();
  const { data: community } = useCommunity(subdomain);
  const user = useAuthenticatedUser<CommunityMember>();
  const discordAuth = useOauth2('discord');
  const t = useTranslations('settings.linked-accounts');

  const title = `${t('connect')} ${t('discord.title')}`;

  const isAdmin = roleIsAtLeast(user?.data?.role, 'admin');
  const shouldShowHint = isAdmin && community?.requiredFields?.linkDiscord;

  return (
    <TaskCard
      title={title}
      type="discord"
      className="px-200 py-300"
      icon={TASK_CONFIG.discord.icon}
      hint={
        shouldShowHint && (
          <TaskCardHint
            icon={<QuestionFilled />}
            tooltip={t.rich('discord.hint', {
              link: chunks => (
                <Link href={`/cw/${subdomain}/settings/security#access`} className="underline">
                  {chunks}
                </Link>
              ),
            })}
          >
            {t('discord.hint-trigger')}
          </TaskCardHint>
        )
      }
    >
      <Button
        leftIcon={<DiscordBrand />}
        size="lg"
        className="w-full text-white bg-task-type-discord hover:bg-task-type-discord-hover active:bg-task-type-discord-press"
        onClick={() => discordAuth.open()}
      >
        {title}
      </Button>
    </TaskCard>
  );
};

export default ConnectDiscord;
